import { CastctlFeatureSelection } from './types';

/** Main console / non-reporting-limited castctl defaults (automation opted in). */
const DEFAULT_CASTCTL_FEATURES_SELECTION: CastctlFeatureSelection = {
  workloadAutoscaler: true,
  autoscaler: true,
  reliabilityMetrics: false,
};

/** Reporting trial / limited console: cost monitoring only. */
const COST_MONITORING_ONLY_CASTCTL_FEATURES_SELECTION: CastctlFeatureSelection =
  {
    workloadAutoscaler: false,
    autoscaler: false,
    reliabilityMetrics: false,
  };

export const getCastctlFeatureSelectionDefaults = (
  limitAutomationConsole: boolean
): CastctlFeatureSelection =>
  limitAutomationConsole
    ? COST_MONITORING_ONLY_CASTCTL_FEATURES_SELECTION
    : DEFAULT_CASTCTL_FEATURES_SELECTION;
